import {useContext} from 'react';

import {ToastContext} from './ToastsProvider';

export const useToast = () => {
  const toastHelpers = useContext(ToastContext);

  return toastHelpers;
};
